import BlokWrapper from "@/contents/integrations/BlokWrapper"
import { SanityDecoration } from "@/contents/molecules/SanityDecoration"
import { FeaturesContainer as FeaturesContainerContent } from "@/contents/sanityTypes"
import SanityImageField from "@/integrations/sanity/components/SanityImageField"
import SanityRichTextField from "@/integrations/sanity/components/SanityRichTextField"
import FeaturesContainer from "@/ui/organisms/FeaturesContainer"

export interface SanityFeaturesContainerProps {
  content: FeaturesContainerContent
}

const SanityFeaturesContainer = ({ content }: SanityFeaturesContainerProps) => {
  return (
    <BlokWrapper contents={content} menuColor="paper">
      <FeaturesContainer
        title={<SanityRichTextField value={content.title} />}
        color={content.color}
        decoration1={
          content.formDecoration1?.image ? (
            <SanityDecoration
              asset={content.formDecoration1.image.asset}
              position={content.formDecoration1.position ?? {}}
              size={content.formDecoration1.size ?? {}}
              absolute
            />
          ) : undefined
        }
        decoration2={
          content.formDecoration2?.image ? (
            <SanityDecoration
              asset={content.formDecoration2.image.asset}
              position={content.formDecoration2.position ?? {}}
              size={content.formDecoration2.size ?? {}}
              absolute
            />
          ) : undefined
        }
        card={
          content.card
            ? {
                title: <SanityRichTextField value={content.card.title} />,
                imageDefault: content.card.items?.imageDefault ? (
                  <SanityImageField
                    asset={content.card.items.imageDefault}
                    responsive
                    objectFit="contain"
                    height="100%"
                    objectPosition="center"
                  />
                ) : undefined,
                imageSelected: content.card.items?.imageSelected ? (
                  <SanityImageField
                    asset={content.card.items.imageSelected}
                    responsive
                    objectFit="contain"
                    height="100%"
                    objectPosition="center"
                  />
                ) : undefined,
                items:
                  content.card.items?.items?.map((item) => ({
                    title: <SanityRichTextField value={item.title} />,
                    description: (
                      <SanityRichTextField value={item.description} />
                    ),
                  })) ?? [],
                infoBarItems: content.card.stats?.items?.map((x) => ({
                  title: <SanityRichTextField value={x.title} />,
                  description: <SanityRichTextField value={x.description} />,
                })),
              }
            : undefined
        }
      />
    </BlokWrapper>
  )
}

export default SanityFeaturesContainer
